import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import QuemSomos from "./pages/QuemSomos";
import Metodologia from "./pages/Metodologia";
import Servicos from "./pages/Servicos";
import Servico from "./pages/Servico";
import Projetos from "./pages/Projetos";
import Noticias from "./pages/Noticias";
import NoticiaDetail from "./pages/NoticiaDetail";
import Contato from "./pages/Contato";
import Legal from "./pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-white">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/metodologia-de-obra" element={<Metodologia />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/servicos/:slug" element={<Servico />} />
            <Route path="/projetos" element={<Projetos />} />
            <Route path="/projetos/:categoria" element={<Projetos />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/noticias/:slug" element={<NoticiaDetail />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/politica-de-privacidade" element={<Legal />} />
            <Route path="/termos-de-uso" element={<Legal />} />
            <Route path="/lgpd" element={<Legal />} />
            <Route path="/politica-de-cookies" element={<Legal />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <CookieBanner />
      </div>
    </BrowserRouter>
  );
}

export default App;
